// 30 age-appropriate craft ideas for Play Group & Nursery (2-5 years)
// Categories: paper, nature, festival, sensory, sanskaar, learning

export const craftsPool = [
  {
    id: 1,
    title: "Paper Plate Peacock",
    category: "Bharatiya",
    difficulty: "Easy",
    time: "20 min",
    icon: "🦚",
    palette: "from-teal-400 to-blue-500",
    materials: ["Paper plate", "Colourful craft paper", "Glue", "Googly eyes", "Marker"],
    steps: [
      "Cut the paper plate in half — one half will be the peacock's body",
      "Cut long teardrop feathers from coloured paper",
      "Glue the feathers around the top of the plate like a fan",
      "Draw the face and stick googly eyes",
      "Wave your peacock and dance like it's raining!"
    ],
    learn: "Colours, shapes, and love for India's national bird."
  },
  {
    id: 2,
    title: "Cotton Ball Cloud",
    category: "Nature",
    difficulty: "Easy",
    time: "15 min",
    icon: "☁️",
    palette: "from-sky-300 to-blue-400",
    materials: ["Cotton balls", "Blue paper", "Glue", "Blue crayon"],
    steps: [
      "Draw a big cloud outline on blue paper",
      "Squish cotton balls a little to soften them",
      "Glue cotton inside the cloud shape",
      "Draw raindrops falling down",
      "Sing 'Rain, Rain, Go Away!'"
    ],
    learn: "Fine motor skills and understanding of weather."
  },
  {
    id: 3,
    title: "Handprint Ganesha",
    category: "Bharatiya",
    difficulty: "Easy",
    time: "25 min",
    icon: "🕉️",
    palette: "from-orange-400 to-red-500",
    materials: ["Poster paint (any)", "White chart paper", "Marker", "Sparkles"],
    steps: [
      "Paint your palm and press it firmly on the paper — this is Ganesha's body",
      "Use fingerprints for hands and feet",
      "Draw a small elephant head on top of the palm print",
      "Add eyes, tilak, and a modak in his hand",
      "Sprinkle sparkles and say 'Ganpati Bappa Morya!'"
    ],
    learn: "Reverence for tradition and creative body-art."
  },
  {
    id: 4,
    title: "Diya Painting",
    category: "Festival",
    difficulty: "Easy",
    time: "30 min",
    icon: "🪔",
    palette: "from-amber-400 to-orange-500",
    materials: ["Clay diya (plain)", "Acrylic colours", "Glitter glue", "Small paint brush"],
    steps: [
      "Wipe the diya clean",
      "Paint the outside with your favourite bright colour",
      "Once dry, dot small designs with glitter glue",
      "Let it dry overnight",
      "Light it on Diwali evening with mummy or papa"
    ],
    learn: "Colours, festivals, and Bharatiya tradition."
  },
  {
    id: 5,
    title: "Rangoli with Colored Rice",
    category: "Bharatiya",
    difficulty: "Medium",
    time: "30 min",
    icon: "🌸",
    palette: "from-pink-400 to-fuchsia-500",
    materials: ["Rice", "Food colours", "Chart paper", "Glue", "Bowl"],
    steps: [
      "Mix rice with different food colours in bowls",
      "Let rice dry on paper for an hour",
      "Draw a simple rangoli outline on chart paper",
      "Apply glue inside sections and sprinkle coloured rice",
      "Shake gently to remove extra rice"
    ],
    learn: "Patience, symmetry, and Bharatiya art."
  },
  {
    id: 6,
    title: "Leaf Print Painting",
    category: "Nature",
    difficulty: "Easy",
    time: "20 min",
    icon: "🍃",
    palette: "from-emerald-400 to-green-600",
    materials: ["Fresh leaves (various shapes)", "Poster paint", "Paper", "Old newspaper"],
    steps: [
      "Collect leaves from the garden with parents",
      "Spread newspaper on the table",
      "Dip a leaf in paint (vein side down)",
      "Press it firmly on the paper",
      "Lift gently — see the beautiful leaf print!"
    ],
    learn: "Nature awareness, textures, and creativity."
  },
  {
    id: 7,
    title: "Ice Cream Stick Puppet",
    category: "Story",
    difficulty: "Easy",
    time: "20 min",
    icon: "🎭",
    palette: "from-yellow-400 to-orange-500",
    materials: ["Ice cream sticks", "Coloured paper", "Markers", "Glue", "Googly eyes"],
    steps: [
      "Draw and cut characters from Panchatantra on paper",
      "Glue each character to an ice cream stick",
      "Add googly eyes and details",
      "Now tell a story with your puppets!",
      "Practise the story of 'The Clever Rabbit and the Lion'"
    ],
    learn: "Storytelling, imagination, and confidence."
  },
  {
    id: 8,
    title: "Paper Kite for Makar Sankranti",
    category: "Festival",
    difficulty: "Medium",
    time: "25 min",
    icon: "🪁",
    palette: "from-rose-400 to-pink-500",
    materials: ["Coloured paper (square)", "String", "Crayons", "Ribbon"],
    steps: [
      "Fold a square paper diagonally to make a kite shape",
      "Colour it with your favourite designs",
      "Attach a string to the centre",
      "Stick a long ribbon tail at the bottom",
      "Hold it high and run around the room!"
    ],
    learn: "Shapes, festival culture, and movement."
  },
  {
    id: 9,
    title: "Toilet Roll Cow",
    category: "Recycled",
    difficulty: "Easy",
    time: "20 min",
    icon: "🐄",
    palette: "from-amber-300 to-yellow-500",
    materials: ["Toilet paper roll", "White & black paint", "Googly eyes", "Pink paper", "Marker"],
    steps: [
      "Paint the roll white with black patches",
      "Cut ear shapes from pink paper and stick them",
      "Add googly eyes and draw a smile",
      "Draw a bell around the neck",
      "Make friends: gaumata is sacred, so treat her with love!"
    ],
    learn: "Recycling, reverence for gau mata, and Bharatiya values."
  },
  {
    id: 10,
    title: "Finger Print Butterfly",
    category: "Nature",
    difficulty: "Easy",
    time: "15 min",
    icon: "🦋",
    palette: "from-violet-400 to-fuchsia-500",
    materials: ["Multiple paint colours", "White paper", "Black marker"],
    steps: [
      "Draw a simple butterfly outline on white paper",
      "Dip your finger in bright paints",
      "Press fingerprints inside the wings",
      "Draw the body and antennae with black marker",
      "Add spots and a little smile!"
    ],
    learn: "Fine motor skills and understanding of insects."
  },
  {
    id: 11,
    title: "Paper Bag Elephant Puppet",
    category: "Animals",
    difficulty: "Medium",
    time: "25 min",
    icon: "🐘",
    palette: "from-stone-400 to-gray-500",
    materials: ["Brown paper bag", "Grey paper", "Googly eyes", "Marker", "Glue"],
    steps: [
      "Cut a long trunk shape from grey paper",
      "Cut two ear shapes",
      "Glue trunk in front of the paper bag",
      "Stick ears on the sides and eyes on top",
      "Now use your hand to make the elephant talk!"
    ],
    learn: "Animal awareness and imaginative play."
  },
  {
    id: 12,
    title: "Om (ॐ) Salt Dough",
    category: "Sanskaar",
    difficulty: "Medium",
    time: "40 min",
    icon: "🕉️",
    palette: "from-orange-400 to-red-600",
    materials: ["1 cup flour", "½ cup salt", "Water", "Gold paint"],
    steps: [
      "Mix flour, salt and water to make dough",
      "Shape it into the Om (ॐ) symbol with parents' help",
      "Let it dry in the sun for 6 hours",
      "Paint it with beautiful gold colour",
      "Place it in the puja area with love"
    ],
    learn: "Bharatiya symbols and hand-shaping skills."
  },
  {
    id: 13,
    title: "Paper Plate Sun",
    category: "Nature",
    difficulty: "Easy",
    time: "15 min",
    icon: "☀️",
    palette: "from-yellow-400 to-orange-500",
    materials: ["Paper plate", "Yellow & orange paint", "Marker", "Yellow paper strips"],
    steps: [
      "Paint the plate yellow with orange edges",
      "Cut long yellow paper strips",
      "Glue strips around the plate like sun rays",
      "Draw a smiling face on the sun",
      "Say 'Namaste Surya Bhagwan!'"
    ],
    learn: "Sun as life-giver and cheerful expressions."
  },
  {
    id: 14,
    title: "Rakhi Making",
    category: "Festival",
    difficulty: "Medium",
    time: "30 min",
    icon: "🎗️",
    palette: "from-rose-400 to-red-500",
    materials: ["Red thread", "Small beads", "Sparkly stickers", "Cardboard cut-out"],
    steps: [
      "Draw a small flower on cardboard and cut it out",
      "Decorate the flower with stickers and beads",
      "Attach a long red thread behind it",
      "Tie it on your brother's or friend's wrist",
      "Promise to always love and protect each other"
    ],
    learn: "Bond of love and the story of Raksha Bandhan."
  },
  {
    id: 15,
    title: "Cotton Ball Sheep",
    category: "Animals",
    difficulty: "Easy",
    time: "15 min",
    icon: "🐑",
    palette: "from-slate-300 to-gray-400",
    materials: ["Paper plate", "Cotton balls", "Black paper", "Googly eyes", "Glue"],
    steps: [
      "Cut a small oval from black paper for the sheep's face",
      "Glue it on the paper plate",
      "Cover the rest of the plate with cotton balls",
      "Add googly eyes and small legs",
      "Baaa-baaa! Meet your fluffy friend"
    ],
    learn: "Textures and animal identification."
  },
  {
    id: 16,
    title: "Pasta Necklace",
    category: "Wearable",
    difficulty: "Easy",
    time: "20 min",
    icon: "📿",
    palette: "from-amber-300 to-yellow-500",
    materials: ["Uncooked penne pasta", "Poster paint", "String", "Bowl"],
    steps: [
      "Paint pasta pieces in bright colours",
      "Let them dry on a plate",
      "Thread painted pasta on a long string",
      "Tie the ends together",
      "Wear your Bharatiya-style haar!"
    ],
    learn: "Colour patterns, threading and self-decoration."
  },
  {
    id: 17,
    title: "Flower Petal Garland",
    category: "Nature",
    difficulty: "Medium",
    time: "20 min",
    icon: "🌺",
    palette: "from-pink-400 to-rose-500",
    materials: ["Fallen flower petals", "Thread", "Needle (with parent)", "Scissors"],
    steps: [
      "Collect fallen petals from the garden — do not pluck",
      "With mummy's help, thread each petal through the middle",
      "Continue until the string is full",
      "Tie the ends to make a beautiful mala",
      "Offer it in the puja area"
    ],
    learn: "Respect for nature and traditional offerings."
  },
  {
    id: 18,
    title: "Cardboard Tabla",
    category: "Music",
    difficulty: "Medium",
    time: "30 min",
    icon: "🥁",
    palette: "from-orange-500 to-red-600",
    materials: ["Empty round container", "Brown paper", "Rubber bands", "Marker"],
    steps: [
      "Cover the round container with brown paper",
      "Stretch a piece of paper over the top",
      "Secure with rubber bands like a real tabla head",
      "Draw a black circle in the centre (siyahi)",
      "Play 'Dha Dhin Dhin Dha!'"
    ],
    learn: "Bharatiya music and rhythm."
  },
  {
    id: 19,
    title: "Sock Puppet Snake",
    category: "Story",
    difficulty: "Easy",
    time: "15 min",
    icon: "🐍",
    palette: "from-lime-400 to-green-600",
    materials: ["Old sock", "Googly eyes", "Red paper", "Glue"],
    steps: [
      "Slide the sock onto your hand",
      "Glue two googly eyes on top",
      "Cut a red forked tongue and glue at the mouth",
      "Sway your hand like a snake charmer",
      "Practise saying 'Sssssssss…'"
    ],
    learn: "Imagination and animal sounds."
  },
  {
    id: 20,
    title: "Handprint Peepal Tree",
    category: "Nature",
    difficulty: "Easy",
    time: "20 min",
    icon: "🌳",
    palette: "from-emerald-500 to-green-700",
    materials: ["Green paint", "Brown crayon", "White paper"],
    steps: [
      "Draw a brown tree trunk with roots on white paper",
      "Paint your palm green",
      "Press handprints around the top of the trunk as leaves",
      "Let it dry",
      "Learn: peepal gives us oxygen 24 hours!"
    ],
    learn: "Nature respect and understanding of sacred trees."
  },
  {
    id: 21,
    title: "Paper Ganesha Mukut",
    category: "Bharatiya",
    difficulty: "Medium",
    time: "30 min",
    icon: "👑",
    palette: "from-amber-500 to-yellow-600",
    materials: ["Yellow chart paper", "Stapler", "Glitter", "Stickers", "Ribbon"],
    steps: [
      "Cut a long strip of yellow chart paper — long enough to fit around your head",
      "Cut zigzag or crown shapes at the top",
      "Decorate with glitter and stickers",
      "Staple the ends to fit your head",
      "You are ready for Ganesh Chaturthi!"
    ],
    learn: "Festival readiness and creative decoration."
  },
  {
    id: 22,
    title: "Paper Boat Race",
    category: "Recycled",
    difficulty: "Medium",
    time: "20 min",
    icon: "⛵",
    palette: "from-blue-400 to-indigo-500",
    materials: ["Old newspaper", "Water tub", "Straws (for blowing)"],
    steps: [
      "Fold newspaper into the classic paper boat shape",
      "Make 2-3 boats with friends",
      "Fill a big tub with water",
      "Race the boats by blowing on them",
      "The first boat to reach the other side wins!"
    ],
    learn: "Folding, floating, and friendly competition."
  },
  {
    id: 23,
    title: "Painted Rock Pets",
    category: "Nature",
    difficulty: "Easy",
    time: "25 min",
    icon: "🪨",
    palette: "from-stone-400 to-gray-600",
    materials: ["Smooth rocks", "Acrylic paints", "Small brushes", "Marker"],
    steps: [
      "Wash and dry the rocks",
      "Paint them as little bugs, cats or elephants",
      "Add details with markers",
      "Let them dry in the sun",
      "Give them names and take them home!"
    ],
    learn: "Creativity and love for pets/animals."
  },
  {
    id: 24,
    title: "Sanskrit Aksharmala Book",
    category: "Sanskaar",
    difficulty: "Medium",
    time: "45 min",
    icon: "📖",
    palette: "from-orange-500 to-amber-600",
    materials: ["Small notebook", "Markers", "Stickers", "Glue"],
    steps: [
      "On each page, write one Sanskrit letter (अ, आ, इ...)",
      "Draw or paste a picture that starts with that sound",
      "Add stickers to decorate",
      "Practise saying each letter loudly",
      "Make one page every day for a month"
    ],
    learn: "Sanskrit basics and love for letters."
  },
  {
    id: 25,
    title: "Chana Dal Sensory Bin",
    category: "Sensory",
    difficulty: "Easy",
    time: "15 min setup",
    icon: "🫘",
    palette: "from-yellow-400 to-amber-500",
    materials: ["Big tray", "Chana dal or rajma", "Small cups", "Spoons", "Small toys"],
    steps: [
      "Pour chana dal into the tray",
      "Add spoons, cups, and small toys",
      "Let the child scoop, pour, hide and find",
      "Feel the different textures with hands",
      "Play for 20-30 minutes"
    ],
    learn: "Sensory exploration and calm focus."
  },
  {
    id: 26,
    title: "Paper Cup Bell",
    category: "Music",
    difficulty: "Easy",
    time: "15 min",
    icon: "🔔",
    palette: "from-yellow-500 to-amber-600",
    materials: ["Paper cup", "String", "A small bead", "Marker", "Sparkles"],
    steps: [
      "Poke a hole in the bottom of the cup",
      "Thread the string with the bead at the end inside",
      "Tie a knot outside the cup",
      "Decorate the cup like a temple bell",
      "Shake it and hear the ting-ting sound"
    ],
    learn: "Cause & effect, and puja-style sounds."
  },
  {
    id: 27,
    title: "Torn Paper Mandala",
    category: "Bharatiya",
    difficulty: "Easy",
    time: "20 min",
    icon: "🌀",
    palette: "from-fuchsia-400 to-purple-500",
    materials: ["Coloured paper", "White paper", "Glue"],
    steps: [
      "Tear coloured paper into small pieces",
      "Draw a circle on white paper",
      "Glue paper pieces from centre to edges in a circular pattern",
      "Try to keep it symmetrical",
      "Admire your peaceful mandala"
    ],
    learn: "Symmetry, patience and traditional art."
  },
  {
    id: 28,
    title: "Bindi Art on Paper",
    category: "Bharatiya",
    difficulty: "Easy",
    time: "15 min",
    icon: "🔴",
    palette: "from-red-500 to-rose-600",
    materials: ["Sheet of coloured bindis", "White paper", "Marker"],
    steps: [
      "Draw a simple pattern like a flower, peacock or heart",
      "Stick bindis along the outline",
      "Fill in the shape with more bindis",
      "Mix colours and sizes",
      "Your Bharatiya masterpiece is ready!"
    ],
    learn: "Pattern making with traditional materials."
  },
  {
    id: 29,
    title: "Paper Chain Toran",
    category: "Festival",
    difficulty: "Easy",
    time: "25 min",
    icon: "🎀",
    palette: "from-orange-500 to-rose-500",
    materials: ["Coloured paper strips", "Glue or stapler", "Marigold shapes cut from paper"],
    steps: [
      "Cut long strips of coloured paper",
      "Loop the first strip and glue it into a ring",
      "Pass the next strip through and glue — forming a chain",
      "Attach paper marigolds every few links",
      "Hang your toran at the front door"
    ],
    learn: "Sequencing, festival prep and home beautification."
  },
  {
    id: 30,
    title: "Handprint Family Tree",
    category: "Family",
    difficulty: "Medium",
    time: "30 min",
    icon: "🌳",
    palette: "from-green-500 to-emerald-600",
    materials: ["Large chart paper", "Different paint colours", "Marker"],
    steps: [
      "Draw a big brown tree trunk with branches",
      "Each family member dips their hand in a different colour",
      "Press handprints on the branches as leaves",
      "Write each person's name under their handprint",
      "Frame it and hang it in the living room"
    ],
    learn: "Family bonding and pride in belonging."
  }
];

export const craftCategories = ["All", "Bharatiya", "Nature", "Festival", "Animals", "Recycled", "Story", "Sensory", "Music", "Sanskaar", "Wearable", "Family"];
